import { GatsbyImage } from 'gatsby-plugin-image';
import get from 'lodash.get';
import React from 'react';

import PageSection from '../Common/PageSection';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import HeadingCtas from './HeadingCtas';
import * as styles from './OverUnderHeader.module.css';

const OverUnderHeader = ({ image, lede, heading, ctaLabel, onCtaClick, ctas }) => {
  let heroImage;
  if (get(image, 'file.contentType') === 'image/svg+xml') {
    heroImage = <img src={image.file.url} alt={image.title} className={styles.heroImage} />;
  } else {
    heroImage = (
      <GatsbyImage alt={get(image, 'title')} className={styles.heroImage} image={get(image, 'gatsbyImageData')} />
    );
  }
  return (
    <PageSection isTopSection={true} wide>
      <div className={styles.heroGrid}>
        <div className={styles.headingContainer}>
          <h1>{heading}</h1>
          {lede && <RichTextConverter copy={lede} />}
        </div>
        {ctas && (
          <div className={styles.ctaContainer}>
            <HeadingCtas ctas={ctas} />
          </div>
        )}
        {heroImage}
      </div>
    </PageSection>
  );
};

OverUnderHeader.propTypes = {
  // myProp: PropTypes.string.isRequired
};

export default OverUnderHeader;
